import React from 'react';

// Render as text, including model-produced summaries: never interpret HTML.
export default function VoiceTaskContent({ content }: { content: string }) {
  return <div className="space-y-4 text-sm leading-6 text-gray-800">
    {content.split(/\n\s*\n|~/).filter(Boolean).map((paragraph, index) => {
      const match = paragraph.match(/^(Request|Next action|Context|Contact|Respond):\s*([\s\S]*)$/);
      return <div key={index}>
        {match ? <><div className="font-semibold text-gray-900">{match[1]}</div><div className="whitespace-pre-line">{match[2]}</div></> : <div className="whitespace-pre-line">{paragraph}</div>}
      </div>;
    })}
  </div>;
}
